import type { TreeNodeDefinition } from '@trimble/ui-components/solidjs';

import type { FxWorkspaceTreeItem } from './fx-workspace-tree.types';

export type FxReferencesViewMode = 'tree' | 'flat';

function isIntermediateReferenceKind(
  kind: FxWorkspaceTreeItem['kind'] | undefined
): boolean {
  return (
    kind === 'referenceCategory' ||
    kind === 'referenceMission' ||
    kind === 'referenceRuns' ||
    kind === 'referenceFolder'
  );
}

export function flattenFxReferenceNodes(
  nodes: TreeNodeDefinition<FxWorkspaceTreeItem>[]
): TreeNodeDefinition<FxWorkspaceTreeItem>[] {
  return nodes.flatMap((node) => {
    const kind = node.data?.kind;
    if (kind === 'references' || isIntermediateReferenceKind(kind)) {
      return [];
    }

    if (kind === 'reference') {
      return [{ ...node, parentId: undefined }];
    }

    return [node];
  });
}
